import { useMemo } from "react";
import type { AtmosphereType } from "../../utils/types/AtmosphereType";
import { useCarConfigSelector } from "../../redux/store";
import { appendAtmospheresWithMonthlyPrice } from "../../utils/atmosphereUtils";

export const useAphLbxAtmospheres = (): AtmosphereType[] => {
    const atmospheres = useCarConfigSelector((state) => state.carConfigAtmosphere.atmospheres);
    const finance = useCarConfigSelector((state) => state.carConfigAtmosphere.finance);

    const enrichedAtmospheres =
        finance.state === "complete" ? appendAtmospheresWithMonthlyPrice([...atmospheres], finance.cars) : atmospheres;
    return useMemo(() => enrichedAtmospheres, [finance.cars]);
};
